import { ExtendedPropertiesType, TagsType } from "@multiweb/types/multiweb";
import { DELETE_FORM, INIT_FORM } from "./constants";
import { IDeleteFormAction, IInitFormAction } from "./types";

/**
 * Akce pro inicializaci formuláře.
 *
 * @param formKey Klíč formláře.
 * @param extendedProperties Extended properties formuláře.
 * @param tags Tags formuláře.
 */
export const createInitFormAction = (
    formKey: string,
    extendedProperties: ExtendedPropertiesType,
    tags: TagsType,
): IInitFormAction => ({
    type: INIT_FORM,
    payload: {
        extendedProperties,
        tags,
    },
    meta: {
        formKey,
    },
});

/**
 * Akce pro smazání formuláře ze store.
 *
 * @param formKey Klíč formláře.
 */
export const createDeleteFormAction = (formKey: string): IDeleteFormAction => ({
    type: DELETE_FORM,
    meta: {
        formKey,
    },
});
